import React from 'react';
import { Link } from 'gatsby';

const SanityLink = ({ children, link, ...props }) => {
	const internalSanityLink = link?.linkType === 'internal';
	const externalSanityLink = link?.linkType === 'external';

	if (internalSanityLink) {
		if (link.internalLink._type === 'projectCategories') {
			return (
				<Link
					to={`/projects/${link.internalLink.slug.current}`}
					{...props}
					activeClassName="current"
				>
					{children}
				</Link>
			);
		} else if (link.internalLink._type === 'project') {
			return (
				<Link
					to={`/projects/${link.internalLink.slug.current}`}
					{...props}
					activeClassName="current"
				>
					{children}
				</Link>
			);
		} else if (link.internalLink._type === 'articleCategories') {
			return (
				<Link
					to={`/articles/${link.internalLink.slug.current}`}
					{...props}
					activeClassName="current"
				>
					{children}
				</Link>
			);
		} else if (link.internalLink._type === 'article') {
			return (
				<Link
					to={`/articles/${link.internalLink.slug.current}`}
					{...props}
					activeClassName="current"
				>
					{children}
				</Link>
			);
		} else {
			return (
				<Link
					to={`/${link.internalLink.slug.current}`}
					{...props}
					activeClassName="current"
				>
					{children}
				</Link>
			);
		}
	}
	if (externalSanityLink) {
		return (
			<a
				href={link.href}
				target={link.blank ? `_blank` : null}
				{...props}
			>
				{children}
			</a>
		);
	}
};

export default SanityLink;
